import React, { FunctionComponent } from 'react';

const Links:FunctionComponent = () => {
  return (
    <div className="links container">
      <h2>Boost your links today</h2>
      <button className="btn-rounded">Get Started</button>
    </div>
  )
}

export default Links;